var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Optimization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 25v38h-4V25h4zM52 63h4V33h-4v30zM48.44 9.68L38 15.73l6.42 1.68C41.5 29.35 29 41.33 12 41.33v4c18.94 0 32.93-13.45 36.28-26.9L54.44 20l-6-10.32zM44 63h4V37h-4v26zm-8 0h4V44h-4v19zm-8 0h4V49h-4v14zm-8 0h4V52h-4v11zm-8 0h4V53h-4v10z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Optimization.5b983e0e.svg";
export { SvgJ2Optimization as ReactComponent };